import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import statusClasses from '../../../utils/Status';

const StatusDot = ({ status }) => {
  return (
    <span className={classNames(statusClasses(status), 'status-dot')} id={`status-${status}-dot`} />
  );
};
StatusDot.propTypes = {
  status: PropTypes.string.isRequired
};

export default StatusDot;
